import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsBillingInformation";
import { COLORS } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(orderConfirmationBillingInformationStyles, {
    billingInformationTitle: {
        variant: "h3",
        as: "h3",
        css: css`
            @media print {
                font-size: 15px;
            }
            padding-top: 0;
            margin-bottom: 0;
        `,
    },
    billingAddressTitle: {
        variant: "h4",
        as: "h4",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    billingInformationBillingAddressGridItem: {
        width: [12, 12, 6, 6, 6],
        printWidth: 12,
        css: css`
            flex-direction: column;
            p {
                font-size: 13px;
                font-weight: 500;
            }
        `,
    },
});
